import type { TokenResponse } from "@/types";
import { browserStorage } from "@/utils/browserStorage";

export const TOKEN_STORAGE_KEY = "exordos.access_token";
const REFRESH_TOKEN_STORAGE_KEY = "exordos.refresh_token";

export function getStoredAccessToken(): string | null {
  return browserStorage.get(TOKEN_STORAGE_KEY);
}

export function getStoredRefreshToken(): string | null {
  return browserStorage.get(REFRESH_TOKEN_STORAGE_KEY);
}

/**
 * Keeps a rotated refresh token without moving the session onto the grant it
 * came from, and hands the access token back unstored.
 *
 * A grant asked for another project answers with a token pair of its own. The
 * refresh token is kept, because an installation that rotates them would leave
 * the session holding a spent one, while the access token is the caller's to
 * carry on the one request that speaks for that project.
 */
export function storeRotatedRefreshToken(tokenResponse: TokenResponse): string {
  if (tokenResponse.refresh_token) {
    browserStorage.set(REFRESH_TOKEN_STORAGE_KEY, tokenResponse.refresh_token);
  }

  return tokenResponse.access_token;
}

export function storeTokenResponse(tokenResponse: TokenResponse): string {
  browserStorage.set(TOKEN_STORAGE_KEY, tokenResponse.access_token);

  if (tokenResponse.refresh_token) {
    browserStorage.set(REFRESH_TOKEN_STORAGE_KEY, tokenResponse.refresh_token);
  } else {
    browserStorage.remove(REFRESH_TOKEN_STORAGE_KEY);
  }

  return tokenResponse.access_token;
}

export function clearStoredAuthTokens(): void {
  browserStorage.remove(TOKEN_STORAGE_KEY);
  browserStorage.remove(REFRESH_TOKEN_STORAGE_KEY);
}
